import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 32px;
  border-bottom: 1px solid #b7b8c1;
  box-sizing: border-box;
  min-height: 276px;
`
export const WineProducer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 10px;
`

export const WineProducerText = styled.div`
  font: var(--typography-22-30-regular);
  color: #121432;
  margin-left: 16px;
`

export const WineName = styled.div`
  font-weight: bold;
  font-size: 32px;
  line-height: 39px;
  color: #121432;
  margin-bottom: 8px;
  display: flex;
  word-break: break-word;
`
export const WineSpecification = styled.div`
  font-weight: 500;
  font-size: 19px;
  line-height: 140%;
  color: #121432;
`
export const ScoreWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 212px;
  height: 212px;
  margin-right: 24px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
`

export const WineInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  box-sizing: border-box;
`
export const ScoreLabel = styled.div`
  font: var(--typography-19-23-semibold);
  color: #a0a1ad;
  margin-left: 10px;
`

export const ProducerLogo = styled.img`
  display: flex;
  width: 212px;
  height: 212px;
`
